const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : WebsocketStream
 */

function WebsocketStream(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

WebsocketStream.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_WebsocketStream = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const WebsocketStream_null_Idle = new StateJS.State('Idle', this._statemachine).entry(() => {
    this.WebsocketStream_pendingLogs_var = [];
    this.WebsocketStream_streamURL_var = '';
    this.clearSocket();
    this.bus.emit('websocket', new Event.Stopped_WebsocketStreamMsg(this.name, 'websocket'));
  });
  const WebsocketStream_null_Starting = new StateJS.State('Starting', this._statemachine).entry(() => {
    this.WebsocketStream_null_Starting_startedAt_var = this.timestamp();
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.WebsocketStream_startingTimeoutTimerId_var, 10000));
    this.WebsocketStream_websocket_var = this.createSocket();
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.WebsocketStream_startingTimeoutTimerId_var));
    this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.WEBSOCKETSTART, this.timestamp() - this.WebsocketStream_null_Starting_startedAt_var));
  });
  const WebsocketStream_null_WaitForFirstMessage = new StateJS.State('WaitForFirstMessage', this._statemachine).entry(() => {
    this.WebsocketStream_null_WaitForFirstMessage_startedAt_var = this.timestamp();
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.WebsocketStream_firstMessageTimeoutTimerId_var, this.adjustBackoff()));
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.WebsocketStream_firstMessageTimeoutTimerId_var));
    this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.WEBSOCKETFIRST, this.timestamp() - this.WebsocketStream_null_WaitForFirstMessage_startedAt_var));
  });
  const WebsocketStream_null_Streaming = new StateJS.State('Streaming', this._statemachine).entry(() => {
    this.WebsocketStream_waitDelay_var = this.WebsocketStream_initialWaitDelay_var;
    this.bus.emit('websocket', new Event.Playing_WebsocketStreamMsg(this.name, 'websocket'));
  });
  const WebsocketStream_null_Timeout = new StateJS.State('Timeout', this._statemachine).entry(() => {
    this.bus.emit('websocket', new Event.Timeout_WebsocketStreamMsg(this.name, 'websocket'));
  });
  const WebsocketStream_null_Fail = new StateJS.State('Fail', this._statemachine).entry(() => {
    this.bus.emit('websocket', new Event.StreamError_WebsocketStreamMsg(this.name, 'websocket'));
  });
  _initial_WebsocketStream.to(WebsocketStream_null_Idle);
  WebsocketStream_null_Fail.to(WebsocketStream_null_Idle);
  WebsocketStream_null_Timeout.to(WebsocketStream_null_Idle);
  WebsocketStream_null_Streaming.to(WebsocketStream_null_Idle).on(Event.Stop_WebsocketStreamMsg).when((stop) => stop.port === 'websocket' && stop.type === 'stop');
  WebsocketStream_null_WaitForFirstMessage.to(WebsocketStream_null_Idle).on(Event.Stop_WebsocketStreamMsg).when((stop) => stop.port === 'websocket' && stop.type === 'stop');
  WebsocketStream_null_Starting.to(WebsocketStream_null_Idle).on(Event.Stop_WebsocketStreamMsg).when((stop) => stop.port === 'websocket' && stop.type === 'stop');
  WebsocketStream_null_Idle.to(WebsocketStream_null_Starting).on(Event.Play_WebsocketStreamMsg).when((play) => play.port === 'websocket' && play.type === 'play').effect((play) => {
    this.WebsocketStream_streamURL_var = play.streamURL;
  });
  WebsocketStream_null_WaitForFirstMessage.to(WebsocketStream_null_Timeout).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.WebsocketStream_firstMessageTimeoutTimerId_var));
  WebsocketStream_null_Starting.to(WebsocketStream_null_Timeout).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.WebsocketStream_startingTimeoutTimerId_var));
  WebsocketStream_null_Streaming.to(WebsocketStream_null_Fail).on(Event.WsClose_WebsocketStream).when((wsClose) => wsClose.port === 'websocketPort' && wsClose.type === 'wsClose');
  WebsocketStream_null_WaitForFirstMessage.to(WebsocketStream_null_Fail).on(Event.WsClose_WebsocketStream).when((wsClose) => wsClose.port === 'websocketPort' && wsClose.type === 'wsClose');
  WebsocketStream_null_Starting.to(WebsocketStream_null_Fail).on(Event.WsClose_WebsocketStream).when((wsClose) => wsClose.port === 'websocketPort' && wsClose.type === 'wsClose');
  WebsocketStream_null_WaitForFirstMessage.to(WebsocketStream_null_Streaming).on(Event.WsMessage_WebsocketStream).when((wsMessage) => wsMessage.port === 'websocketPort' && wsMessage.type === 'wsMessage');
  WebsocketStream_null_Starting.to(WebsocketStream_null_WaitForFirstMessage).on(Event.WsOpen_WebsocketStream).when((wsOpen) => wsOpen.port === 'websocketPort' && wsOpen.type === 'wsOpen');
  WebsocketStream_null_Streaming.to(WebsocketStream_null_Fail).on(Event.WsError_WebsocketStream).when((wsError) => wsError.port === 'websocketPort' && wsError.type === 'wsError');
  WebsocketStream_null_WaitForFirstMessage.to(WebsocketStream_null_Fail).on(Event.WsError_WebsocketStream).when((wsError) => wsError.port === 'websocketPort' && wsError.type === 'wsError');
  WebsocketStream_null_Starting.to(WebsocketStream_null_Fail).on(Event.WsError_WebsocketStream).when((wsError) => wsError.port === 'websocketPort' && wsError.type === 'wsError');
  this._statemachine.on(Event.Log).when((log) => log.port === 'log' && log.type === 'log').effect((log) => {
    this.sendLog(log.payload);
  });
};
WebsocketStream.prototype.timestamp = function () {
  return Date.now();
};

WebsocketStream.prototype.adjustBackoff = function () {
  if (this.WebsocketStream_waitDelay_var < this.WebsocketStream_maxWaitDelay_var) {
    /* eslint-disable-next-line operator-assignment */
    this.WebsocketStream_waitDelay_var = 2 * this.WebsocketStream_waitDelay_var;
  }
  return this.WebsocketStream_waitDelay_var;
};

WebsocketStream.prototype.sendLog = function (WebsocketStream_sendLog_payload_var) {
  if ((this.WebsocketStream_websocket_var != null)) {
    try {
      if (this.WebsocketStream_websocket_var.readyState === WebSocket.OPEN) {
        // eslint-disable-next-line no-restricted-syntax
        for (const log of this.WebsocketStream_pendingLogs_var) { this.WebsocketStream_websocket_var.send(log); }
        this.WebsocketStream_pendingLogs_var = [];
        this.WebsocketStream_websocket_var.send(WebsocketStream_sendLog_payload_var);
      }
    } catch (error) {
      console.log(error);
    }
  } else {
    this.WebsocketStream_pendingLogs_var.push(WebsocketStream_sendLog_payload_var);
  }
};

WebsocketStream.prototype.createSocket = function () {
  this.WebsocketStream_client_var.logBreadcrumb('createSocket');
  try {
    const ws = new WebSocket(this.WebsocketStream_streamURL_var);
    ws.binaryType = 'arraybuffer';
    ws.addEventListener('open', () => {
      this.WebsocketStream_client_var.logBreadcrumb('ws open');

      this.bus.emit('websocketPort', new Event.WsOpen_WebsocketStream(this.name, 'websocketPort'));
      this.bus.emit('statusInput', new Event.WebsocketStatus_StatusMsg(this.name, 'statusInput', Enum.WebsocketStatus_ENUM.OPEN));

      this.WebsocketStream_client_var.streamStatusCallback('websocket-open');
    });
    ws.addEventListener('close', () => {
      console.log('WS CLOSED');
      this.WebsocketStream_client_var.logBreadcrumb('ws close');

      this.bus.emit('websocketPort', new Event.WsClose_WebsocketStream(this.name, 'websocketPort'));
      this.bus.emit('statusInput', new Event.WebsocketStatus_StatusMsg(this.name, 'statusInput', Enum.WebsocketStatus_ENUM.CLOSED));

      this.WebsocketStream_client_var.streamStatusCallback('websocket-closed');
    });
    ws.addEventListener('error', (error) => {
      console.error('WS ERROR:', error);
      this.WebsocketStream_client_var.logException(error);

      this.bus.emit('websocketPort', new Event.WsError_WebsocketStream(this.name, 'websocketPort'));
      this.bus.emit('statusInput', new Event.WebsocketStatus_StatusMsg(this.name, 'statusInput', Enum.WebsocketStatus_ENUM.ERROR));
    });
    ws.addEventListener('message', (event) => {
      this.bus.emit('websocketPort', new Event.WsMessage_WebsocketStream(this.name, 'websocketPort'));
      if (typeof event.data === 'string') {
        let parsedMessage = null;
        try {
          parsedMessage = JSON.parse(event.data);
          if (parsedMessage && 'type' in parsedMessage) {
            switch (parsedMessage.type) {
              case 'ping': {
                const wsLatency_var = this.timestamp() - parsedMessage.timestamp;
                this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.WSLATENCY, wsLatency_var));
                break;
              }
              case 'event':
                this.WebsocketStream_client_var.streamStatusCallback(parsedMessage.state);
                break;
              default:
                break;
            }
          }
        } catch (error) {
          this.bus.emit('websocket', new Event.FormatPacket_WebsocketStreamMsg(this.name, 'websocket', event.data));
        }
      } else {
        this.bus.emit('websocket', new Event.VideoPacket_WebsocketStreamMsg(this.name, 'websocket', event.data));
      }
    });
    return ws;
  } catch (error) {
    console.error(error);
    this.WebsocketStream_client_var.logException(error);

    this.bus.emit('websocket', new Event.StreamError_WebsocketStreamMsg(this.name, 'websocket'));
    this.bus.emit('statusInput', new Event.WebsocketStatus_StatusMsg(this.name, 'statusInput', Enum.WebsocketStatus_ENUM.ERROR));
  }
  return null;
};

WebsocketStream.prototype.clearSocket = function () {
  this.WebsocketStream_client_var.logBreadcrumb('clear socket');
  if ((this.WebsocketStream_websocket_var != null)) {
    try {
      if (this.WebsocketStream_websocket_var.readyState === WebSocket.OPEN) {
        // eslint-disable-next-line no-restricted-syntax
        for (const log of this.WebsocketStream_pendingLogs_var) { this.WebsocketStream_websocket_var.send(log); }
        this.WebsocketStream_pendingLogs_var = [];
        this.WebsocketStream_websocket_var.close();
        this.bus.emit('statusInput', new Event.WebsocketStatus_StatusMsg(this.name, 'statusInput', Enum.WebsocketStatus_ENUM.CLOSED));
      }
    } catch (error) {
      console.log(error);
      this.WebsocketStream_client_var.logException(error);
      this.bus.emit('statusInput', new Event.WebsocketStatus_StatusMsg(this.name, 'statusInput', Enum.WebsocketStatus_ENUM.ERROR));
    }
  }
  this.WebsocketStream_websocket_var = undefined;
};

WebsocketStream.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

WebsocketStream.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

WebsocketStream.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

WebsocketStream.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

WebsocketStream.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tstreamURL = ${this.WebsocketStream_streamURL_var}`;
  result += `\n\tinitialWaitDelay = ${this.WebsocketStream_initialWaitDelay_var}`;
  result += `\n\tclient = ${this.WebsocketStream_client_var}`;
  result += `\n\tfirstMessageTimeoutTimerId = ${this.WebsocketStream_firstMessageTimeoutTimerId_var}`;
  result += `\n\tstartedAt = ${this.WebsocketStream_null_Starting_startedAt_var}`;
  result += `\n\tstartingTimeoutTimerId = ${this.WebsocketStream_startingTimeoutTimerId_var}`;
  result += `\n\tmaxWaitDelay = ${this.WebsocketStream_maxWaitDelay_var}`;
  result += `\n\twebsocket = ${this.WebsocketStream_websocket_var}`;
  result += `\n\twaitDelay = ${this.WebsocketStream_waitDelay_var}`;
  result += `\n\tpendingLogs = ${this.WebsocketStream_pendingLogs_var}`;
  result += `\n\tstartedAt = ${this.WebsocketStream_null_WaitForFirstMessage_startedAt_var}`;
  result += '';
  return result;
};

module.exports = WebsocketStream;
